module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-ios.7f8a8e97.svg";